define( function() {
	return window.document;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/document.js
// module id = 15
// module chunks = 0